import React, { useState } from 'react';
import { Box, Typography, Collapse, useMediaQuery } from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import { albumApi } from '../../../../api/album';
import AlbumHorizontalSimpleCard from '../../../../components/card/AlbumHorizontalSimpleCard';
import theme from '../../../../theme';

const useOtherVersions = (sourceId, albumSource) =>
  useQuery({
    queryKey: ['otherVersions', sourceId, albumSource],
    queryFn: () => albumApi.getOtherVersions(sourceId, albumSource),
    select: (res) => res.data,
    enabled: !!sourceId && !!albumSource,
  });

const OtherVersionsSection = ({ albumInfo }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const isMobile = useMediaQuery(theme.breakpoints.down('lg'));

  const { data: otherVersions = [] } = useOtherVersions(
    albumInfo?.sourceId,
    albumInfo?.albumSource,
  );

  if (otherVersions.length === 0) return null;

  const handleToggle = () => {
    if (isMobile) {
      setIsExpanded(!isExpanded);
    }
  };

  return (
    <Box>
      <Box
        onClick={handleToggle}
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          cursor: isMobile ? 'pointer' : 'default',
          mb: 1,
        }}
      >
        <Typography
          color={theme.palette.black[9]}
          fontSize={{ xs: 16, md: 18, lg: 18 }}
          fontWeight={'bold'}
        >
          버전 ({otherVersions.length})
        </Typography>
        {isMobile &&
          (isExpanded ? (
            <ArrowDropUpIcon sx={{ color: theme.palette.black[9], width: 24, height: 24 }} />
          ) : (
            <ArrowDropDownIcon sx={{ color: theme.palette.black[9], width: 24, height: 24 }} />
          ))}
      </Box>
      <Box
        sx={{
          borderTop: `1px solid ${theme.palette.grey.line}`,
        }}
      >
        <Collapse in={isMobile ? isExpanded : true}>
          <Box
            sx={{
              borderLeft: `1px solid ${theme.palette.grey.line}`,
              borderRight: `1px solid ${theme.palette.grey.line}`,
              borderBottom: `1px solid ${theme.palette.grey.line}`,
            }}
          >
            {otherVersions.map((version) => (
              <AlbumHorizontalSimpleCard
                key={version.sourceId}
                albumId={version.id}
                sourceId={version.sourceId}
                albumSource={version.albumSource}
                slug={version.slug}
                imageUrl={version.imageUrl}
                albumName={version.title}
                contentRating={version.contentRating}
                releaseDate={version.releaseDate}
                artist={albumInfo?.artist}
                imageSize={{ xs: 40, md: 80, lg: 40 }}
                referrerSection="issues"
              />
            ))}
          </Box>
        </Collapse>
      </Box>
    </Box>
  );
};

export default OtherVersionsSection;
